import { $ne as __ne, createExpressionOperator } from "../../_predicates";
const $ne = createExpressionOperator(__ne);
export {
  $ne
};
